import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { pluralize } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { ANALYTICS_OBJECT_TYPE_APP_REQUESTS, ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT } from '../../../../../analytics/Events';
import AppRequestCommentsModal from './AppRequestCommentsModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function AppRequestCount(props) {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const [isModalOpen, setModalOpenFlag] = useState(false);
  const onRequestCountClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT,
      objectType: ANALYTICS_OBJECT_TYPE_APP_REQUESTS,
      objectId: props.appKey
    });
    setModalOpenFlag(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: onRequestCountClick,
      appearance: "link",
      children: pluralize('request', props.requestCount, true)
    }), isModalOpen && /*#__PURE__*/_jsx(AppRequestCommentsModal, _objectSpread(_objectSpread({}, props), {}, {
      onClose: () => setModalOpenFlag(false)
    }))]
  });
}